import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入公共css
import './assets/css/style.scss'
Vue.config.productionTip = false

// 引入element
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/element-variables.scss'
Vue.use(ElementUI);

// 引入axios
import http from 'http'
import axios from 'axios'
import qs from 'qs'
Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.prototype.qs = qs
Vue.prototype.http = http;
Vue.prototype.HOST = "/api";
import $ from 'jquery'

// 引入公共js
import common from "./components/common"
Vue.prototype.common = common


// 登录
// router.beforeEach((to, from, next) => {
//     if (to.path == '/login') {
//         sessionStorage.removeItem('username');
//     }
//     let user = JSON.parse(sessionStorage.getItem('username'));
//     if (!user && to.path != '/login') {
//         next({ path: '/login' })
//     } else {
//         next()
//     }
// })


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')